import { useCallback, useMemo, useState } from "react";
import {
  EmptyFilters,
  Filters,
  FiltersSetter,
  SearchQuery
} from "@/services/api/types";

export interface DreamerAttachmentToolbarState {
  filters: Filters;
  setFilters: FiltersSetter;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  searchQuery: SearchQuery | undefined;
}

export const useDreamerAttachmentToolbarState =
  (): DreamerAttachmentToolbarState => {
  const [filters, setFiltersState] = useState<Filters>(EmptyFilters);
  const [searchTerm, setSearchTerm] = useState("");

  const setFilters = useCallback<FiltersSetter>((filtersOrUpdater) => {
    setFiltersState((prev) =>
      typeof filtersOrUpdater === "function"
        ? filtersOrUpdater(prev)
        : filtersOrUpdater
    );
  }, []);

  const searchQuery = useMemo<SearchQuery | undefined>(
    () => (searchTerm ? { term: searchTerm } : undefined),
    [searchTerm]
  );

  return { filters, setFilters, searchTerm, setSearchTerm, searchQuery };
};
